<template>
  <div class="motivos-anulacion">
    <AppMenu />
    <BaseBreadcrumb title="Motivos de anulación" :breadcrumbs="breadcrumbs"></BaseBreadcrumb>
    <v-card class="mt-3 mx-3 pa-4">
      <MotivosDeAnulacion />
    </v-card>
  </div>
</template>
<script>
import AppMenu from "./menu/AppMenu.vue";
import MotivosDeAnulacion from "./configuration/MotivosDeAnulacion.vue";

// Los motivos son de la empresa, no de cada caja: se editan aquí, una sola vez.
export default {
  name: "MotivosDeAnulacionPagina",
  components: { AppMenu, MotivosDeAnulacion },
  data: () => ({
    breadcrumbs: [
      { text: "Inicio", disabled: false, to: "/pos" },
      { text: "Motivos de anulación", disabled: true },
    ],
  }),
};
</script>
